import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@aimsos/i18n';

const HASH_CHIP =
  'inline-flex items-center rounded-md bg-surface-muted px-1.5 py-0.5 font-mono text-[11px] text-content-secondary';

/**
 * Expanded Audit Ledger detail — matches HTL V1 proto:
 * ID · Previous hash · This hash · Full artifact · Outcome.
 */
function AuditLedgerRowDetail({ entry }) {
  const { t } = useTranslation('work-queues-app');
  const navigate = useNavigate();
  const fullArtifact = entry.artifactTitle
    ? `${entry.artifactId} · ${entry.artifactTitle}`
    : entry.artifactId;

  const handleArtifactClick = useCallback(() => {
    navigate(`../${entry.artifactId}`, { relative: 'path' });
  }, [navigate, entry.artifactId]);

  return (
    <div className="flex flex-col gap-1.5 py-3 text-[12px] leading-relaxed text-content-secondary">
      <div>
        <span className="font-semibold text-content-muted">{t('activity.id')}: </span>
        <span className="font-mono text-content">{entry.id}</span>
      </div>
      <div>
        <span className="font-semibold text-content-muted">{t('activity.previousHash')}: </span>
        <code className={HASH_CHIP}>{entry.prevHash ?? '—'}</code>
      </div>
      <div>
        <span className="font-semibold text-content-muted">{t('activity.thisHash')}: </span>
        <code className={HASH_CHIP}>{entry.hash}</code>
      </div>
      <div>
        <span className="font-semibold text-content-muted">{t('activity.fullArtifact')}: </span>
        <button
          type="button"
          onClick={handleArtifactClick}
          className="font-mono text-content underline-offset-2 hover:text-brand-500 hover:underline"
        >
          {fullArtifact}
        </button>
      </div>
      <div>
        <span className="font-semibold text-content-muted">{t('activity.outcome')}: </span>
        <span className="text-content">{entry.outcome}</span>
      </div>
    </div>
  );
}

export default AuditLedgerRowDetail;
